import {LoadMoreForm} from "./LoadMoreForm.js";
export const initializeLoadMoreButtons = () => {
  document.querySelectorAll("div.news-load-more").forEach((form) => new LoadMoreForm(form));
};
